/*
 * @Descripttion: 
 * @Author: huxianglong
 * @Date: 2023-07-03 10:59:04
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-01-25 18:15:59
 */
import request from '@/service'
import type {
  ILoginData,
  ILoginParam,
  IQuestionAnswerType,
  IQuestionData,
  ISubmitPaper,
  PlanData,
  IUploadData,
  EndMessageData,
} from './types'

export const loginApi = async (params: ILoginParam) => {
  return request.post<ILoginData>({ url: 'student/login', data: params })
}

export const getPlanLists = () => {
  return request.get<PlanData[]>({ url: '/student/plan/list' })
}

// 获取考生须知
export const getNotice = (planId: number) => {
  return request.get<string>({ url: `/student/plan/notice/${planId}`})
}
// 计划列表调取开始考试
export const getStartExam = (planId: number) => {
  return request.get<boolean>({ url: `/student/plan/start/${planId}`})
}

// 检查否点击过开始
export const getCheckStart = (planId: number) => {
  return request.get<boolean>({ url: `/student/plan/start/check/${planId}`})
}

export const getQuestionList = () => {
  return request.get<IQuestionData[]>({ url: '/student/question/list' })
}

export const setQuestionAnswer = (data: IQuestionAnswerType) => {
  return request.post({ url: '/student/question/answer', data })
}

export const getCandidateEndTime = () => {
  return request.get<EndMessageData>({ url: '/student/timestamp/end' })
}

// 图片上传oss签名
export const getSignature = () => {
  return request.get({ url: '/token/oos/signature' })
}

export const setUpload = (data: FormData, opt?: { width: number }) => {
  return request.post<IUploadData>({
    url: `Common/AsyncUpload?width=${opt?.width || 300}`,
    data,
  })
}

export const submitPaper = () => {
  return request.post<ISubmitPaper>({ url: '/student/paper/submit' })
}
export const setCapture = (url: string) => {
  return request.post({ url: '/student/capture', data: { pic: url} })
}

export const getCaptureCount = () => {
  return request.get<{ count: number }>({ url: '/student/capture/count' })
}

 // 获取当前域名信息
 export const getDomainInfo = (data: {
  url: string
 }) => {
  return request.post({ url: '/apply/domain/info', data })
}
 // 切换屏幕
 export const getSwitchCount = () => {
  return request.get<number>({ url: '/student/screen/switch' })
}